import { LicensingTable } from '../LicensingTable/LicensingTable';
import { ProductCompatibilityTable } from '../ProductCompatibilityTable/ProductCompatibilityTable';
import { PublisherInfoTable } from '../PublisherInfoTable/PublisherInfoTable';
import { Separator } from '../Separator/Separator';
import { ProductNutritionLabelsProps } from './types';

export const ProductNutritionLabels = ({
  compatibility,
  licensing,
  publisher,
  microcopy,
  className = '',
}: ProductNutritionLabelsProps) => {
  return (
    <div className={className}>
      <Separator className="hidden md:block" />
      <ProductCompatibilityTable
        {...compatibility}
        microcopy={microcopy.compatibility}
      />
      <Separator />
      <LicensingTable {...licensing} microcopy={microcopy.licensing} />
      <Separator />
      <PublisherInfoTable {...publisher} microcopy={microcopy.publisher} />
    </div>
  );
};
